import React from "react";

export default function AnnouncementBar() {
  return null;
}
